<script>
  import Text from '@components/general/text.svelte'
  import Button from '@components/buttons/button.svelte'
  import Block from '@components/general/block'
  import { Crown, Clock, ChevronRight } from 'lucide-svelte'
  import { page } from '@inertiajs/svelte'
  import { formatDateText } from '@lib/utils/date'
  import { isFuture } from 'date-fns'

  let user = $derived($page.props.user)
  let membership = $derived(user?.current_membership)

  // Block title reflects current membership state
  let title = $derived(
    membership
      ? (membership.status === 'inactive' ? 'Pending' : 'Member')
      : 'No membership'
  )

  // Human-readable status label
  let statusLabel = $derived({
    active: 'Active',
    canceled: 'Cancelled',
    inactive: 'Processing payment',
  }[membership?.status] || 'Unknown')
</script>

<!-- Only shown for non-admin users -->
{#if !user.is_admin}
  <Block.Element label="Membership" {title}>

    <!-- Active or past membership details -->
    {#if membership}
      <Block.Items>
        <Block.Item label="Status" value={statusLabel} />

        {#if membership.entitlement_end_date}
          <Block.Item
            label={isFuture(membership.entitlement_end_date) ? 'Valid until' : 'Expired'}
            value={formatDateText(membership.entitlement_end_date)}
          />
        {/if}
      </Block.Items>
    {/if}

    <!-- Status messages -->
    {#if membership?.status === 'inactive'}

      <!-- Payment processing -->
      <div class="flex items-center gap-2 text-amber-600 mt-2">
        <Clock size={16} />
        <Text class="text-amber-600 text-sm font-medium">Payment is being processed</Text>
      </div>
      
      <Text class="text-gray-500 text-sm">Your membership will be activated shortly once payment is confirmed.</Text>

    {:else if !user.has_active_membership}

      <!-- No active membership -->
      {#if user.has_pending_invoice_request}

        <!-- Pending invoice request -->
        <div class="flex items-center gap-2 text-amber-600 mb-3">
          <Clock size={16} />
          <Text class="text-amber-600 text-sm font-medium">Invoice request pending</Text>
        </div>

        <Text class="text-gray-500 text-sm">Your invoice request is being reviewed. You'll receive an email once it's approved.</Text>

      {:else}

        <!-- Upgrade prompt -->
        <Text class="text-gray-500 text-sm">Upgrade your membership to access more content and features.</Text>
        <Button variant="primary" path="/register" text="Upgrade membership" Icon={Crown} class="mt-3" />

      {/if}

    {/if}

    <!-- Link to full membership page -->
    <Button variant="link" path="/settings/membership" text="View membership details" Icon={ChevronRight} class="text-gray-500/80 text-smaller underline hover:text-gray-600 mt-6" />

  </Block.Element>
{/if}
